import role from "./role/de";
import release from "./release/de";

export default {
  role,
  release,
  settings: "Settings",
  roles: "Roles",
};
